import styled from "styled-components";

const Separator = styled.hr`
  border-top: 1px solid;
  width: 100%;
`;

export default Separator;
